import React from 'react'
import { useI18n } from '../../i18n'
import type { ReadinessGap } from '../../services/complianceReadinessApi'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

interface Props {
  gaps?: ReadinessGap[]
}

export default function ReadinessGapList({ gaps = [] }: Props) {
  const { t } = useI18n()
  if (!gaps.length) return null

  return (
    <ul className={wfStyles.innerStack}>
      {gaps.map((gap) => (
        <li key={gap.canonicalControlKey} className={wfStyles.listItem}>
          <p className={wfStyles.itemTitle}>
            <strong>{gap.canonicalControlKey}</strong>
            {gap.controlTitle ? ` — ${gap.controlTitle}` : ''}
          </p>
          <p className={wfStyles.itemMeta}>
            {t('complianceReadiness.missing', 'Missing')}:
            {(gap.missing || []).length
              ? ` ${gap.missing!.join(', ')}`
              : ` ${t('complianceReadiness.evidenceRequired', 'evidence required')}`}
          </p>
          {gap.reason ? <p className={wfStyles.itemMeta}>{gap.reason}</p> : null}
        </li>
      ))}
    </ul>
  )
}
